export default __webpack_public_path__ + "images/12cbc59272823ebd1bcebf0caa99b191-wine.jpg";